import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { http } from '@/shared/lib/api';

export interface AppNotification {
  id: string;
  type: string;
  data: Record<string, unknown>;
  link: string | null;
  read_at: string | null;
  created_at: string;
}

interface ListResponse {
  success: true;
  data: AppNotification[];
  meta: {
    total: number;
    unread_count: number;
    page: number;
    page_size: number;
    total_pages: number;
  };
}

export function useNotifications(enabled = true) {
  return useQuery<ListResponse>({
    queryKey: ['notifications'],
    queryFn: () =>
      http.get<ListResponse>('/api/notifications', {
        query: { page: 1, page_size: 20 },
      }),
    enabled,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

export function useMarkNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ids?: string[]) =>
      http.post<{ success: true }>('/api/notifications/mark-read', ids ? { ids } : {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
